// If already authenticated, bounce to wherever the operator was heading. Auth gate for authed routes lives in AuthedLayout.
import { useEffect } from 'react';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { useAuth } from '../../lib/auth';
import { LoginForm } from './LoginForm';

/**
 * Redirect target is safe only if it's a same-origin PATH — checked HERE, at the point of use,
 * since `location.search` still carries the raw URL regardless of the route's validateSearch.
 * Rejects: absolute URLs, protocol-relative ("//evil.example" — browsers read as absolute), non-paths.
 */
export function safeRedirect(value: unknown): string | null {
  if (typeof value !== 'string' || !value) return null;
  if (!value.startsWith('/')) return null;
  if (value.startsWith('//')) return null;
  return value;
}

export function LoginRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const search = useSearch({ strict: false }) as { redirect?: string };
  const redirect = safeRedirect(search.redirect);

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      // The fleet is only the fallback.
      void navigate({ to: redirect ?? '/' });
    }
  }, [isLoading, isAuthenticated, navigate, redirect]);

  return <LoginForm />;
}
